/**
 * Stage constructor
 * @constructor editor.actionbar.TopBar
 * @param {object} dom DOM
 */

fx.ns("desktop.common.actionbar", class TopBar extends fx.components.VBox {
    
	constructor(creation, options)
	{
		super(creation);
		
		this.creation = creation;
		this.options = Object.assign(this.defaults, options || {});

		this.listenUpdates(creation.elements, true);
	}

	get defaults()
	{
		// uploadProgress : the upload ring around the order button (the print editor only)
		return  { order : true, exit : true, edit : false, uploadProgress : false};
	}

	onReady()
	{
		super.onReady();

		if (this.orderButton && this.orderBackground)
		{
			this.on("click", this.onOrder, this.orderButton);
			this.on("click", this.onOrder, this.orderBackground);
			this.on("mouseover", this.onOrderHover, this.orderBackground);
			this.on("mouseout", this.onOrderOut, this.orderBackground);
			this.on("mouseover", this.onOrderHover, this.orderButton);
			this.on("mouseout", this.onOrderOut, this.orderButton);

			// the uploader raises its events on the editor's model, not on the creation this bar shows
			let uploader = this.uploadProgress ? fx.service("MediasUploader") : null;
			if (uploader && uploader.creationModel)
				this.on("event", this._onUploadEvent, uploader.creationModel);

			this.updateUploadProgress();
		}
		if (this.exitButton)
			this.on("click", this.onExit, this.exitButton);
	}

	create()
	{
		super.create();

		if (this.options.order)
		{
			// with the upload ring, the label sits 16px under the button so that the ring fits
			// between them ; the box grows by as much, the button keeping its size
			let ring = this.options.uploadProgress;
			this.orderButton = new fx.components.IconButton({className : "orderButton", icon:fx.assets.OrderIcon, label : fx.text("Commander"), filled : true, textMargin : ring ? 16 : 10});
            this.orderButton.attr("data-testid", "edition-order");
			this.addChild(this.orderButton, {left:"center", height:ring ? 91 : 85, width:ring ? 91 : 85} );

			// the price pill, opening leftwards from the button on hover
			this.orderBackground = new fx.components.Box("orderBackground");
			this.addChild(this.orderBackground, {top:0, right: 0, height:TopBar.BUTTON_SIZE, width: TopBar.BUTTON_SIZE} );

			this.orderPrice = new desktop.common.actionbar.OrderPrice(this.creation.totalPrice);
			this.orderBackground.addChild(this.orderPrice, {top:0, right:TopBar.BUTTON_SIZE, height:TopBar.BUTTON_SIZE});

			if (ring)
			{
				this.uploadProgress = new desktop.common.actionbar.OrderUploadProgress();
				this.addChild(this.uploadProgress, {top:-8, left:0, width:"100%", height:140});
			}
		}

		if (this.options.exit)
		{
			this.exitButton = new fx.components.IconButton({icon:fx.assets.LeaveIcon, label : fx.text("Sauver & Quitter"), className : "exit"});
			this.exitButton.toolTip = fx.text("Sauver & Quitter");
			this.exitButton.toolTypeStyle = { position : "left", positionMargin : 20 };
			
			this.addChild(this.exitButton, {left:"center", height:70, width:70} );		
		}
	}

	// diameter of the order button, and height of its price pill
	static get BUTTON_SIZE()
	{
		return 64;
	}

	// width of the price pill once open
	static get PILL_WIDTH()
	{
		return 198;
	}

	onOrder()
    {
		this.trigger("order");
	}

	onExit()
	{
		this.trigger("exit");
	}

	// "hover" shows the price of the OrderPrice and widens the upload ring with the pill
	onOrderHover(){
		this.orderBackground.width(TopBar.PILL_WIDTH);
		this.addClass("hover");
	}

	onOrderOut(){
		this.orderBackground.width(TopBar.BUTTON_SIZE);
		this.removeClass("hover");
	}

	_onUploadEvent(e)
	{
		switch (e.detail.event.type)
		{
			case "upload-file" :
			case "upload-file-progress" :
			case "upload-error" :
			case "upload-finished" :
			case "files-not-uploaded" :
				this.updateUploadProgress();
				break;
		}
	}

	// the ring and its caption show while photos are uploading, and go once nothing is left to send
	updateUploadProgress()
	{
		if (!this.uploadProgress)
			return;

		let uploader = fx.service("MediasUploader");
		let uploading = uploader.uploading && uploader.total > 0 && uploader.percentage < 100;

		if (uploading)
			this.uploadProgress.percentage = uploader.percentage;

		this.toggleClass("uploading", uploading);
	}

	_updatePrice()
	{
		if (this.orderPrice)
			this.orderPrice.price = this.creation.totalPrice;
	}

	onDataUpdated()
	{
		this._updatePrice();
	}

	onChildUpdated(action)
	{
		if (action.impacts("quantity"))
			this._updatePrice();
	}
	
});